import { IconDefinition } from "./types";

const circleCheck: IconDefinition = {
  iconName: "circle-check",
  width: 512,
  height: 512,
  svgPathData:
    "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-464a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM379.7 178.8l-14.1 19.4-122.1 167.9-16.5 22.7-92.7-92.7 33.9-33.9 53 53 105.6-145.2 14.1-19.4 38.8 28.2z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "circle-check",
  unicode: 0xf058,
};

export { circleCheck };
